import connect from 'components/Shared/connect';
import { getBrandContent } from 'views/ProductlistPage/selectors';
import { isProductlistPage } from 'models/ProductlistPageModel';
import { NO_ELEMENT, rm } from 'utils';
import styles from './brandContentBottom.scss';
import { ProductListType } from 'models/ProductListType';
import Image from 'components/Shared/Image';
import { Section } from 'components/Section';
import { Cell, Grid } from 'components/Grid';
import { ProductlistPageBrandContent } from 'models/ProductlistPageBrandContent';

const PRODUCT_HIGHLIGHTS_IMAGE = {
  dimensions: {
    width: 600,
    height: 400
  },
  responsive: {
    srcSet: [
      { viewWidth: 767, width: 800, height: 533 },
      { viewWidth: 768, width: 600, height: 400 }
    ],
    sizes: `(min-width: 768px) 768px, 767px`
  }
};

interface MergedProps {
  type: ProductListType;
  brandContent?: ProductlistPageBrandContent;
}

export const BrandContentBottom = connect<MergedProps>(state => ({
  type: isProductlistPage(state.currentPage)
    ? state.currentPage.productlistType
    : ProductListType.Normal,
  brandContent: getBrandContent(state.currentPage)
}))(({ brandContent, type }: MergedProps) => {
  if (brandContent === undefined || type !== ProductListType.BrandCategoryFilter) {
    return NO_ELEMENT;
  }

  if (brandContent.productHighlights === undefined) {
    return NO_ELEMENT;
  }

  return (
    <Section className={styles.productHightlights} title={rm('brand_content_product_highlights')}>
      <Grid gutters="extraLarge" desktop="3" tablet="2" phone="1">
        {brandContent.productHighlights.map(({ image, header, body }) => (
          <Cell key={image.id}>
            <Image
              className={styles.image}
              wrapperClassName={styles.imageWrapper}
              responsive={PRODUCT_HIGHLIGHTS_IMAGE.responsive}
              {...image}
              {...PRODUCT_HIGHLIGHTS_IMAGE.dimensions}
              paddingBottom
            />
            <h4>{header}</h4>
            <p>{body}</p>
          </Cell>
        ))}
      </Grid>
    </Section>
  );
});
